export default class Layout {
  constructor(menuContainer, menuItems = []) {
    this.menuContainer = menuContainer;
    this.menuItems = menuItems;
    this.menuExpanded = false;
    this.menuListElement = null;
  }

  renderMenu() {
    let html = '<ul id="menu_desplegable" class="menu_replegado">';
    html += '<li><a class="bt_toggle" href="#">&#9776; MENU</a></li>';
    for (const item of this.menuItems) {
      const liClass = item.alignRight ? ' class="menu-item-right"' : '';
      html += `<li${liClass}><a id="${item.route}" data-route="${item.route}" class="no-active" href="#/${item.route}">${item.label}</a></li>`;
    }
    html += '</ul>';
    this.menuContainer.innerHTML = html;
    this.menuListElement = this.menuContainer.querySelector('#menu_desplegable');
    this.bindMenuEvents();
  }

  bindMenuEvents() {
    const toggleButton = this.menuContainer.querySelector('.bt_toggle');
    if (!toggleButton) {
      return;
    }
    toggleButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.menuExpanded) {
        this.collapseMenu();
      } else {
        this.expandMenu();
      }
    });
  }

  expandMenu() {
    this.menuExpanded = true;
    if (this.menuListElement) {
      this.menuListElement.classList.remove('menu_replegado');
      this.menuListElement.classList.add('menu_desplegado');
    }
  }

  collapseMenu() {
    this.menuExpanded = false;
    if (this.menuListElement) {
      this.menuListElement.classList.remove('menu_desplegado');
      this.menuListElement.classList.add('menu_replegado');
    }
  }

  closeMenu() {
    this.collapseMenu();
  }

  hasRoute(routeId) {
    return this.menuItems.some((item) => item.route === routeId);
  }

  setActiveRoute(routeId) {
    const links = this.menuContainer.querySelectorAll('a[data-route]');
    links.forEach((link) => {
      if (link.dataset.route === routeId) {
        link.classList.remove('no-active');
        link.classList.add('active');
      } else {
        link.classList.remove('active');
        link.classList.add('no-active');
      }
    });
  }

  clearActiveRoute() {
    this.setActiveRoute(null);
  }

  setHeaderTitle(htmlTitle) {
    const titleNode = document.querySelector('#cabecera_titulo h2');
    if (!titleNode) {
      return;
    }
    titleNode.innerHTML = htmlTitle || '';
  }
}
